import React from 'react'
import { useStateValue } from 'context/store'
import { CircularProgress, Backdrop, makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
   backdrop: {
      zIndex: '10000 !important',
      color: 'white'
   }
}))

const Spinner = ({ open }) => {
   const classes = useStyles()
   const [{ openSpinner = {} }] = useStateValue()

   return (
      <Backdrop className={classes.backdrop} open={openSpinner.open || open}>
         <CircularProgress color="inherit" />
      </Backdrop>
   )
}

export default Spinner
